<script setup lang="ts">
  import PosUiSkeleton from '@/components/pos-v2/ui/PosUiSkeleton.vue';

  /** The list while the catalog loads (plan §5.16): two skeleton cards. */
  const CARDS = [4, 3];
</script>

<template>
  <div class="v2-catalog-loading" aria-busy="true">
    <div v-for="(rows, card) in CARDS" :key="card" class="loading-card">
      <PosUiSkeleton class="loading-title" />
      <div v-for="row in rows" :key="row" class="loading-row">
        <PosUiSkeleton class="row-photo" />
        <div class="row-lines">
          <PosUiSkeleton class="line-name" />
          <PosUiSkeleton class="line-meta" />
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
  .v2-catalog-loading {
    @apply tw-mx-auto tw-w-full;
    max-width: 1120px;

    .loading-card {
      @apply tw-rounded-xl tw-border tw-border-solid tw-border-neutral-200 tw-bg-surface tw-px-4 tw-py-4;

      & + .loading-card {
        @apply tw-mt-3;
      }
    }

    .loading-title {
      @apply tw-mb-3 tw-h-5 tw-w-40;
    }

    .loading-row {
      @apply tw-flex tw-items-center tw-py-3;

      .row-photo {
        @apply tw-mr-3 tw-h-12 tw-w-12 tw-flex-none;
      }

      .row-lines {
        @apply tw-min-w-0 tw-flex-1;
      }

      .line-name {
        @apply tw-h-4 tw-w-1/2;
      }

      .line-meta {
        @apply tw-mt-2 tw-h-3 tw-w-1/3;
      }
    }
  }
</style>
